import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 停止搜寻附近的蓝牙外围设备
export function stopBluetoothDevicesDiscovery(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(
    APINames.Native.STOP_BLUETOOTH_DEVICES_DISCOVERY,
    option
  );
}
